module.exports = __webpack_public_path__ + "img/pztype-4.cb13eeda.png";